import type { PaymentsMessageId } from "./payments.fr";

/** Paiements in German. Same keys and {placeholders} as payments.fr.ts. */
export const paymentsDe: Record<PaymentsMessageId, string> = {
  "payments.tab.payments": "Zahlungen",
  "payments.tab.approvals": "Genehmigungsanfragen",
  "payments.pick": "Wählen Sie eine Zahlung aus der Liste.",
  "payments.loading": "Zahlung wird geladen…",
  "payments.loadFailed": "Diese Zahlung konnte nicht geladen werden.",
  "payments.notFound": "Diese Zahlung wurde nicht gefunden. Laden Sie die Liste neu.",
  "payments.refreshFailed": "Die Zahlung konnte nicht aktualisiert werden: Sie wird im vorherigen Stand angezeigt.",

  "payments.filter.provider": "Zahlungsmittel",
  "payments.filter.status": "Status",
  "payments.filter.all": "Alle",
  "payments.filter.from": "Vom",
  "payments.filter.to": "Bis",
  "payments.filter.duplicates": "Wahrscheinliche Duplikate",
  "payments.filter.clearPro": "Alle Profis",
  "payments.list.loading": "Zahlungen werden geladen…",
  "payments.list.loadFailed": "Die Zahlungen konnten nicht geladen werden.",
  "payments.list.empty": "Keine Zahlungen für diese Filter.",
  "payments.list.aria": "Gebührenzahlungen",
  "payments.list.end": "Ende der Liste",
  "payments.pill.duplicate": "Wahrscheinliches Duplikat",

  "payments.status.pending": "Offen",
  "payments.status.paid": "Bezahlt",
  "payments.status.failed": "Fehlgeschlagen",
  "payments.status.refunded": "Erstattet",
  "payments.status.waived": "Gebühr erlassen",
  "payments.provider.orange_money": "Orange Money",
  "payments.provider.lengo_pay": "Mobile Money",
  "payments.provider.stripe": "Karte (Stripe)",
  "payments.provider.wave": "Wave",
  "payments.feeType.per_job": "Vermittlungsgebühr",
  "payments.feeType.monthly": "Monatsabo",
  "payments.feeType.yearly": "Jahresabo",
  "payments.kind.refund": "Erstattung",
  "payments.kind.credit": "Gutschrift",
  "payments.kind.waive": "Gebührenerlass",
  "payments.kind.mark_paid": "Als bezahlt markiert",

  "payments.detail.versionTitle": "Die angezeigte Version der Zahlung: Jede Korrektur sendet sie mit.",
  "payments.detail.duplicate": "Wahrscheinliches Duplikat",
  "payments.detail.duplicateBody":
    "Eine weitere Zahlung desselben Profis, über denselben Betrag, einige Minuten früher oder später. Prüfen Sie vor der Erstattung:",
  "payments.detail.pro": "Profi",
  "payments.detail.proPayments": "Seine Zahlungen →",
  "payments.detail.transaction": "Referenz beim Anbieter",
  "payments.detail.job": "Anfrage",
  "payments.detail.refunded": "Bereits erstattet",
  "payments.detail.refundable": "Noch erstattungsfähig",
  "payments.detail.credit": "Guthaben des Profis",
  "payments.detail.adjustments": "Korrekturen",
  "payments.detail.noAdjustments": "Keine Korrekturen an dieser Zahlung.",
  "payments.detail.actions": "Korrigieren",
  "payments.detail.neverOptimistic":
    "Nichts wird als erledigt angezeigt, bevor der Server antwortet. Eine Erstattung ohne Antwort des Anbieters wird nie erneut gesendet.",
  "payments.col.kind": "Korrektur",
  "payments.col.amount": "Betrag",
  "payments.col.status": "Stand",
  "payments.col.by": "Von",
  "payments.col.actions": "Aktionen",

  "payments.adjustment.status.pending": "Status unbekannt, wird geprüft",
  "payments.adjustment.status.done": "Erledigt",
  "payments.adjustment.status.failed": "Vom Anbieter abgelehnt",
  "payments.adjustment.status.awaiting_manual_transfer": "Manuelle Überweisung ausstehend",
  "payments.adjustment.status.awaiting_approval": "Wartet auf Genehmigung",
  "payments.adjustment.status.rejected": "Vom Inhaber abgelehnt",
  "payments.adjustment.outcomeUnknownHint":
    "Ohne Antwort an den Anbieter gesendet. Sie wird nie erneut gesendet: Prüfen Sie im Dashboard des Anbieters und schließen Sie sie dann ab.",
  "payments.adjustment.manualHint":
    "Orange Money hat keine automatische Erstattung: Senden Sie das Geld manuell und schließen Sie sie dann mit der Überweisungsreferenz ab.",

  "payments.action.refund": "Erstatten",
  "payments.action.credit": "Gutschreiben",
  "payments.action.waive": "Gebühr erlassen",
  "payments.action.markPaid": "Als bezahlt markieren",
  "payments.action.settle": "Abschließen",
  "payments.action.approve": "Genehmigen",
  "payments.action.reject": "Ablehnen",

  "payments.dialog.refund.title": "Erstatten · {subject}",
  "payments.dialog.refund.body":
    "Die Erstattung wird gespeichert und dann genau einmal an den Anbieter gesendet. Über dem Limit wartet sie auf die Genehmigung eines Inhabers.",
  "payments.dialog.credit.title": "Gutschreiben · {subject}",
  "payments.dialog.credit.body":
    "Ein Guthaben, das von den nächsten Gebühren des Profis abgezogen wird, in derselben Währung.",
  "payments.dialog.waive.title": "Gebühr erlassen · {subject}",
  "payments.dialog.waive.body":
    "Die Gebühr ist nicht mehr geschuldet. Über dem Limit wartet der Erlass auf die Genehmigung eines Inhabers.",
  "payments.dialog.markPaid.title": "Als bezahlt markieren · {subject}",
  "payments.dialog.markPaid.body":
    "Nur mit der Referenz der echten Zahlung (SMS des Profis oder Kontoauszug). Eine Referenz markiert nur eine einzige Zahlung.",
  "payments.dialog.settle.title": "Erstattung abschließen · {subject}",
  "payments.dialog.settle.body":
    "Erfassen Sie, wie die Erstattung ausgegangen ist, nachdem Sie es beim Anbieter geprüft haben.",
  "payments.dialog.approve.title": "Anfrage von {subject} genehmigen",
  "payments.dialog.approve.body": "Die angefragte Korrektur gilt ab sofort. Niemand genehmigt seine eigene Anfrage.",
  "payments.dialog.reject.title": "Anfrage von {subject} ablehnen",
  "payments.dialog.reject.body":
    "Nichts wird erstattet oder erlassen. Die Begründung wird mit der Anfrage gespeichert.",
  "payments.field.amount": "Betrag ({currency})",
  "payments.field.refundHint": "Leer lassen, um alles zu erstatten: {amount}.",
  "payments.field.orangeMoneyReference": "Transaktionsreferenz von Orange Money",
  "payments.field.reference": "Referenz beim Anbieter",
  "payments.field.referenceHint":
    "Vollständig aus der SMS oder dem Kontoauszug kopieren: Buchstaben, Ziffern und . _ : / -",
  "payments.field.outcome": "Ergebnis",
  "payments.field.outcome.done": "Das Geld wurde ausgezahlt",
  "payments.field.outcome.failed": "Die Erstattung ist fehlgeschlagen",

  "payments.problem.reason": "Geben Sie eine Begründung mit mindestens {min} Zeichen an.",
  "payments.problem.amount": "Geben Sie einen Betrag über null ein, mit höchstens zwei Nachkommastellen.",
  "payments.problem.tooMuch": "Das ist mehr, als noch erstattet werden kann.",
  "payments.problem.reference":
    "Kopieren Sie die Referenz vollständig: mindestens {min} Zeichen, nur Buchstaben, Ziffern und . _ : / -.",

  "payments.outcome.done": "{kind} über {amount}: erledigt.",
  "payments.outcome.pending":
    "{kind} über {amount}: Status unbekannt, wird geprüft. Sie wird nicht erneut gesendet; schließen Sie sie nach der Prüfung ab.",
  "payments.outcome.awaiting_manual_transfer":
    "{kind} über {amount} gespeichert: Senden Sie das Geld manuell und schließen Sie sie dann mit der Referenz ab.",
  "payments.outcome.awaiting_approval":
    "{kind} über {amount}: über dem, was Sie allein tun dürfen, wartet auf eine Freigabe.",
  "payments.outcome.failed": "{kind} über {amount} vom Anbieter abgelehnt ({failure}). Es wurde nichts bewegt.",
  "payments.outcome.rejected": "{kind} über {amount} abgelehnt.",

  "payments.approvals.status.pending": "Ausstehend",
  "payments.approvals.status.approved": "Genehmigt",
  "payments.approvals.status.rejected": "Abgelehnt",
  "payments.approvals.loading": "Anfragen werden geladen…",
  "payments.approvals.loadFailed": "Die Genehmigungsanfragen konnten nicht geladen werden.",
  "payments.approvals.empty": "Keine Anfragen hier.",
  "payments.approvals.requested": "Angefragt von {name} am {date}",
  "payments.approvals.permission": "Berechtigung: {permission}",
  "payments.approvals.theirLimit": "Ihr Limit: {amount}",
  "payments.approvals.noPermission": "Diese Person hat diese Berechtigung nicht.",
  "payments.approvals.noLimitInCurrency": "Diese Person hat in dieser Währung kein Limit.",
  "payments.approvals.openPro": "Profi öffnen →",
  "payments.approvals.decided": "Entschieden von {name} am {date}",
  "payments.approvals.openPayment": "Zahlung öffnen →",
  "payments.approvals.own": "Das ist Ihre Anfrage: Ein anderer Inhaber muss darüber entscheiden.",

  "payments.export.month": "Zu exportierender Monat",
  "payments.export.reason": "Begründung (optional)",
  "payments.export.button": "CSV exportieren",
  "payments.export.running": "Export läuft…",
  "payments.export.hint":
    "Die Zahlungen des Monats (UTC) für den Abgleich, ohne Telefonnummer oder E-Mail. Jeder Export wird im Audit-Protokoll erfasst.",
  "payments.export.done": "Export heruntergeladen. Er ist im Audit-Protokoll erfasst.",

  "payments.error.stale":
    "Diese Zahlung hat sich geändert, während Sie sie angesehen haben. Laden Sie sie neu, prüfen Sie und versuchen Sie es erneut.",
  "payments.error.refused":
    "Korrektur abgelehnt: Ihre Rollen enthalten die nötige Funktion nicht. Bitten Sie eine verantwortliche Person um Zugang.",
  "payments.error.approvalRefused":
    "Abgelehnt: Nur ein Inhaber mit APPROVE_PAYMENT_REQUESTS kann entscheiden, und nie über seine eigene Anfrage.",
  "payments.error.invalid":
    "Abgelehnt: Die Zahlung ist nicht mehr im erwarteten Zustand, der Betrag übersteigt den Rest, oder die Referenz wird bereits verwendet. Laden Sie neu und prüfen Sie.",
  "payments.error.outcomeUnknown":
    "Keine Antwort vom Server: Die Korrektur wurde möglicherweise gespeichert. Versuchen Sie es erneut: Derselbe Klick kann nicht zweimal angewendet werden.",

  "payments.refused.notRefundable":
    "Abgelehnt: Nur eine bezahlte Gebühr kann erstattet werden. Laden Sie die Zahlung neu.",
  "payments.refused.nothingToRefund":
    "Abgelehnt: Diese Gebühr ist bereits vollständig erstattet, oder der Rest steht aus. Laden Sie die Zahlung neu.",
  "payments.refused.refundTooLarge":
    "Abgelehnt: Der Betrag übersteigt das, was von dieser Gebühr noch erstattet werden kann.",
  "payments.refused.alreadyAwaitingApproval":
    "Abgelehnt: Ein Erlass dieser Gebühr wartet bereits auf einen Inhaber. Laden Sie die Zahlung neu.",
  "payments.refused.notMarkable":
    "Abgelehnt: Nur eine ausstehende oder fehlgeschlagene Gebühr kann als bezahlt markiert werden. Laden Sie die Zahlung neu.",
  "payments.refused.referenceInUse":
    "Abgelehnt: Mit dieser Orange-Money-Referenz wurde bereits eine andere Gebühr bezahlt. Prüfen Sie die Referenz.",
  "payments.refused.referenceRequired": "Geben Sie die Transaktionsreferenz ein.",
  "payments.refused.alreadySettled": "Diese Erstattung wurde gerade abgeschlossen. Laden Sie sie neu.",
  "payments.refused.alreadyDecided": "Über diese Anfrage wurde gerade entschieden. Laden Sie die Liste neu.",
  "payments.refused.ownRequest": "Abgelehnt: Sie haben diese Anfrage gestellt, also entscheidet ein anderer Inhaber.",
  "payments.refused.approverNotPermitted":
    "Sie haben diese Berechtigung für diesen Betrag nicht, also können Sie nicht entscheiden. Eine andere Person entscheidet.",
  "payments.refused.paymentChanged":
    "Abgelehnt: Die Zahlung hat sich seit der Anfrage geändert. Lehnen Sie sie stattdessen mit Begründung ab.",
  "payments.refused.currencyMismatch": "Abgelehnt: Die Gutschrift muss in der Währung der Gebühr sein.",
  "payments.refused.feeOfAnotherPro": "Abgelehnt: Diese Gebühr wurde von einem anderen Profi bezahlt.",
  "payments.refused.invalidAmount": "Abgelehnt: Der Betrag muss größer als null sein.",
};
